module.exports = __webpack_public_path__ + "img/pdf.5f839045.png";